<div class="d-flex flex-column h-100">
  <div class="left-title-box">
    <div class="left-title">Menu</div>
  </div>
  <div class="left-content flex-grow-1">
    <div class="sidenav">
      <a
        *ngFor="let property of properties; let i = index"
        [routerLink]="property.routerLink"
        routerLinkActive="active"
        ><span class="{{ property.spanClass }}" aria-hidden="true"></span>
        {{ property.name }}</a
      >
    </div>
  </div>
</div>

